import { IStatusBoxProps } from 'iglooform/es/status-box';
import { defineMessages } from 'react-intl';

// role码
export const ROLE = {
  admin: 1,
  businessManager: 2,
  agentHead: 3,
  agent: 4,
  customer: 5,
  agencyDevelopmentManager: 6,
  sbm: 7,
};

// 角色状态码
export const USER_STATUS = {
  active: 1,
  deactivated: 2,
  pending: 3,
};

export const RoleMessages: { [key: number]: { id: string } } = defineMessages({
  [ROLE.admin]: { id: 'Admin' },
  [ROLE.businessManager]: { id: 'Business Manager' },
  [ROLE.agentHead]: { id: 'Agent Head' },
  [ROLE.agent]: { id: 'Agent' },
  [ROLE.customer]: { id: 'Customer' },
  [ROLE.agencyDevelopmentManager]: { id: 'ADM' },
  [ROLE.sbm]: { id: 'Senior Business Manager' },
});

export const UserStatusMessages: { [key: number]: { id: string } } =
  defineMessages({
    [USER_STATUS.active]: { id: 'Active' },
    [USER_STATUS.deactivated]: { id: 'Deactivated' },
    [USER_STATUS.pending]: { id: 'Pending' },
  });

export const UserStatusTypes: { [key: number]: IStatusBoxProps['type'] } = {
  [USER_STATUS.active]: 'success',
  [USER_STATUS.deactivated]: 'failed',
  [USER_STATUS.pending]: 'warning',
};
